const withErrorHandling = (callback) => {
  return (fn) => {
    return async (...args) => {
      try {
        return await fn(...args);
      } catch (error) {
        await callback(error);
      }
    };
  };
};
const withErrorIgnoring = withErrorHandling(() => {
});
export {
  withErrorHandling,
  withErrorIgnoring
};
